import { render, staticRenderFns } from "./Firearm.vue?vue&type=template&id=64860e67&"
import script from "./Firearm.vue?vue&type=script&lang=ts&"
export * from "./Firearm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports